































































































































































































import { Component, Mixins, Ref } from "vue-property-decorator";
import VSignPost from "@/components/Company/VSignPost.vue";
import LogoModal from "@/components/Company/LogoModal.vue";
import VSelect from "@/components/VSelect.vue";
import BusinessSector from "@/models/BusinessSector";
import BusinessSectorMixin from "@/mixins/http/BusinessSectorMixin";
import CompanyMixin, { EDIT_COMPANY } from "@/mixins/http/CompanyMixin";
import WithErrors from "@/directives/WithErrors";
import Company, { Typologies } from "@/models/Company";

@Component({
  components: { VSignPost, VSelect, LogoModal },
  directives: { WithErrors },
})
export default class Edit extends Mixins(BusinessSectorMixin, CompanyMixin) {
  @Ref() readonly logoModal!: LogoModal;
  title = "Aggiungi cliente";
  typologies = [...Typologies];
  businessSectors: { id: string; text: string }[] = [];
  businessLoading = false;
  companyLoading = false;
  currentId = "";
  companyName = "Nuovo cliente";
  logo = "";
  logoToUpload: any = null;

  company = Company.empty();

  async onSubmit() {
    if (this.isNewCompany) {
      this.company = await this.createCompany(this.company);
    } else {
      this.company = await this.updateCompany(this.company);
    }
    await this.uploadLogo();
    this.$router.push({
      name: "company_details",
      params: { id: this.company.id },
    });
  }

  async uploadLogo() {
    if (this.logoToUpload) {
      const data = { logo: this.logoToUpload };
      await this.uploadCompanyLogo(this.company.id, data);
    }
  }

  manageUpload(uploadFiles: any[]) {
    if (uploadFiles.length === 0) {
      return;
    }
    const file = uploadFiles[0];
    this.logoToUpload = file;
    const fr = new FileReader();
    fr.readAsDataURL(file);
    fr.onload = () => {
      this.logo = fr.result as string;
    };
  }

  onUpload() {
    this.logoModal.show();
  }

  onCancel() {
    this.$router.push({ name: "companies" });
  }

  get companyTag() {
    return EDIT_COMPANY;
  }

  get isNewCompany() {
    return !this.currentId;
  }

  async mounted() {
    const sectors: BusinessSector[] = await this.getBusinessSectors();
    this.businessLoading = true;
    this.businessSectors = sectors.map((s) => {
      return {
        id: s.id,
        text: s.name,
      };
    });
    this.businessLoading = false;
    this.currentId = this.$route.params.id;
    if (this.currentId) {
      this.title = "Modifica cliente";
      this.companyLoading = true;
      this.company = await this.getCompany(this.currentId);
      this.companyName = this.company.name;
      this.logo = this.company.croppedLogo || "";
      this.companyLoading = false;
    }
  }
}
